import { render, staticRenderFns } from "./IniciativaModal.vue?vue&type=template&id=413381ab&scoped=true"
import script from "./IniciativaModal.vue?vue&type=script&lang=js"
export * from "./IniciativaModal.vue?vue&type=script&lang=js"
import style0 from "./IniciativaModal.vue?vue&type=style&index=0&id=413381ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413381ab",
  null
  
)

export default component.exports